import { useQuery } from "@tanstack/react-query";
import api from "apis";
import {
  DocumentCreatedUserDto,
  DocumentDetailResponse,
} from "apis/data-contracts";

export interface DocumentDetailResponseWithAny extends DocumentDetailResponse {
  documentData: Record<string, any>;
  companyName: string;
  createdUserDto: DocumentCreatedUserDto;
}

const useDocumentDetailQuery = (documentUuid?: string) => {
  return useQuery({
    queryKey: api.document.getDocumentDetailKey(documentUuid!),
    queryFn: () => api.document.getDocumentDetail(documentUuid!),
    enabled: !!documentUuid,
    select: (res) => res.data.result,
  });
};

export default useDocumentDetailQuery;
